<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div>
        <button-add :pathName="addName" v-if="permissionCodes.indexOf('001011001') !== -1"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @deleteLine="deleteLine" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../../components/Button/ButtonAdd'
  import InputSearch from '../../../../components/Input/InputSearch'
  import TableMain from '../../../../components/Table/TableMain'
  import {api} from '../../../api/ConfigManagement'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nSuccess} from '../../../../utils/notice'
  import {bus} from '../../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSearch,
      ButtonAdd,
      Breadcrumb},
    name: 'config-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: 'Banner配置'
        }],
        addName: 'banner-add',
        searchPlaceholder: '标题',
        searchKey: '',
        deleteTipInfo: '是否确认删除此条配置？',
        tableHead: [{
          prop: 'title',
          label: '标题'
        }, {
          prop: 'responsiblePersonName',
          label: '添加人'
        }, {
          prop: 'createTime',
          label: '添加时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        operationArr: ['modify', 'delete']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      getPage () {
        this.$axios.get(api.getAppletBannerList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.map(v => {
                if (v.createTime) {
                  v.createTime = v.createTime.slice(0, 19)
                }
              })
              this.total = data.length
              this.tableData = data
            }
          })
          .catch(errorHandler('获取信息失败'))
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      search (v) {
        this.pageNum = 1
        this.searchKey = v
        this.getPage()
      },
      // 修改
      goToModifyPage (code) {
        this.$router.push({
          path: `/banner_modify/${code}`
        })
      },
      deleteLine (code) {
        this.$axios.post(api.deleteAppletBannerByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/BannerConfig/BannerManage.vue